const capitalize = (text: any) => {
    if (text != null || text != undefined) {
      return text.replace(/\w\S*/g, function (txt: string) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
    return ''
  }
  
  const formatDate = (data: any) => {
    if (data != null || data != undefined) {
      //converter data no formato YYYY-MM-DD para DD/MM/YYYY
      let dia  = data.split("-")[0];
      let mes  = data.split("-")[1];
      let ano  = data.split("-")[2];
  
      return ano + '/' + ("0"+mes).slice(-2) + '/' + ("0"+dia).slice(-2);
    }
    return 'Sem data informada';
  }

  const formatDateHour = (data: any) => {
    if (data != null || data != undefined) {
      let dia  = data.split("T")[0].split("-")[0];
      let mes  = data.split("T")[0].split("-")[1];
      let ano  = data.split("T")[0].split("-")[2];
      let hora = data.split("T")[1].split(":")[0];
      let min  = data.split("T")[1].split(":")[1];
      let seg  = data.split("T")[1].split(":")[2];
  
      return ano + '/' + ("0"+mes).slice(-2) + '/' + ("0"+dia).slice(-2) + ' - ' + hora + ':' + min + ':' + seg;
    }
    return 'Sem data informada';
  }
  
  const formateNameLayout = (name: string) => {
      return name.replace(/_/g, '').toLowerCase();
  }
  
  
  
  export {
      capitalize, formatDate, formatDateHour, formateNameLayout
  }
  